import { h } from 'vue';

const body = `<h4>Toogle curvature combs</h4>

<p>To show curvature combs, select edge(s), then click this button.
Click button again to hide the curvature combs.</p>

<p><strong>Shortcuts</strong></p>

<ul>
    <li><strong>K</strong>: Toggle curvature combs</li>
</ul>`;

export function ToggleCurvatureCombsTooltip() {
    return h('div', { innerHTML: body });
}
